import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { FormElement, InputText } from 'mailup-web-components'

import { useRecoilState } from 'recoil'

import { modalSaveAsTemplateState } from '../recoil/state/modals'

const InputTitle = ({ onChange }) => {
  const intl = useIntl()
  const [dirty, setDirty] = useState(false)
  const [valid, setValid] = useState(true)

  const [{ title }, setState] = useRecoilState(modalSaveAsTemplateState)

  const handleChangeTitle = ({ target: { value } }) => {
    const valid = value.trim().length
    setDirty(true)
    setValid(valid)

    setState(prev => ({ ...prev, title: value }))
  }

  return (
    <FormElement
      labelFor='templateTitle'
      label={intl.formatMessage({
        id: 'Load.Bee.ModalLabelForTemplate'
      })}
      required
    >
      <InputText
        onChange={handleChangeTitle}
        value={title}
        variant={!valid && dirty ? 'danger' : undefined}
      />
    </FormElement>
  )
}

InputTitle.propTypes = {
  onChange: PropTypes.func
}

export default InputTitle
